import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Pencil } from "lucide-react";
import { CanProject } from "@/app/capabilities/components/can-project";
import { PROJECT } from "@/app/capabilities/permissions";
import type { Secret } from "@/app/secrets/types";
import { SecretSheet } from "../secret-sheet";
import { DeleteSecretButton } from "./delete-button";

export const SecretActions = ({ secret }: { secret: Secret }) => {
  const isStatic = secret.binding.type === "static";

  if (isStatic) {
    return <span className="text-muted-foreground text-sm">Not editable</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <CanProject permission={PROJECT.secrets.update}>
        <SecretSheet
          secret={secret}
          trigger={
            <Button size="icon" variant="ghost">
              <Pencil className="size-4" />
            </Button>
          }
        />
      </CanProject>
      <CanProject permission={PROJECT.secrets.delete}>
        <DeleteSecretButton
          binding={secret.binding.type}
          id={secret.id}
          name={secret.key}
        />
      </CanProject>
    </div>
  );
};
